/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Before_LabelInputs */



/**
* | output |
* | --- |
* | "Before:" |
*
* @param {Compare_Event_Groups_Before_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_before_label = /** @type {((inputs?: Compare_Event_Groups_Before_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Before_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avant :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vor:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prima:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("До:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Antes:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前に：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहले:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Antes:")
	return /** @type {LocalizedString} */ ("Before:")
});